import { NO_CABLE_TYPE_LABEL } from "../constants";
import type { RouteGroupLabelOf } from "./types";

// The plan load and the history patches must name a cable type's group the same way.
export const routeGroupLabelOf: RouteGroupLabelOf = (cableType) =>
  (cableType ?? "").trim() || NO_CABLE_TYPE_LABEL;
